export function formatRelativeTime(unixSeconds) {
  if (!unixSeconds) {
    return '—';
  }

  const diff = Math.max(0, Math.floor(Date.now() / 1000) - unixSeconds);
  if (diff < 60) {
    return `${diff || 1} sec${diff === 1 ? '' : 's'} ago`;
  }
  if (diff < 3600) {
    const m = Math.floor(diff / 60);
    return `${m} min${m === 1 ? '' : 's'} ago`;
  }
  if (diff < 86400) {
    const h = Math.floor(diff / 3600);
    return `${h} hour${h === 1 ? '' : 's'} ago`;
  }
  const d = Math.floor(diff / 86400);
  return `${d} day${d === 1 ? '' : 's'} ago`;
}

export function formatUtcTimestamp(unixSeconds) {
  if (!unixSeconds) {
    return '—';
  }

  const d = new Date(unixSeconds * 1000);
  const parts = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour12: false,
    timeZone: 'UTC',
  }).formatToParts(d);

  const get = (type) => parts.find((p) => p.type === type)?.value ?? '';
  return `${get('hour')}:${get('minute')}:${get('second')} ${get('month')} ${get('day')}, ${get('year')} (UTC)`;
}
